import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import UniqueId from 'vue-unique-id'

import ApiPlugin from "./plugins/api";
import NotificationPlugin from "./plugins/notification";

Vue.config.productionTip = false;

Vue.use(ApiPlugin);
Vue.use(NotificationPlugin);
Vue.use(UniqueId);

import "@/assets/css/app.min.css";
import "@/assets/scss/main.scss";
import 'vue-advanced-cropper/dist/style.css';

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
